// AUTO-GENERATED by scripts/ts/generate-builtin-script-metadata.ts
// Imports and default icon are derived from the matching .raw.js file.
// Safe to edit — this file will not be overwritten once it exists.
import { BuiltInScriptMetadata } from "../builtInsTypes";

const metadata: BuiltInScriptMetadata = {
  name: "Fight Echo",
  id: "fight-echo",
  metadata: {
    imports: ["ping","spark","projectile","self","vector","wait"],
    icon: {
      "backgroundColor": 2431778,
      "layers": [
        {
          "iconKey": "lightning",
          "position": {
            "x": 0,
            "y": 0
          },
          "scale": 0.95,
          "rotation": 4,
          "color": 16761373
        },
        {
          "iconKey": "ping",
          "position": {
            "x": 14,
            "y": 0
          },
          "scale": 0.56,
          "rotation": 15,
          "color": 4751615
        },
        {
          "iconKey": "fireball",
          "position": {
            "x": -9,
            "y": 12
          },
          "scale": 0.59,
          "rotation": -13,
          "color": 4712958
        },
        {
          "iconKey": "delay",
          "position": {
            "x": -5,
            "y": -16
          },
          "scale": 0.67,
          "rotation": 3,
          "color": 16247295
        }
      ]
    },
  },
};

export default metadata;
